import { Component } from 'react';

export class TrashcanSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;

        return (
            <svg
                className={className}
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    opacity="0.3"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 18H8V9H6V18ZM14 18H16V9H14V18ZM10 18H12V7H10V18ZM4 20H18V5H4V20ZM8 3H14V2H8V3ZM22 3H16V0H6V3H0V5H2V22H20V5H22V3Z"
                    fill="#1F4264"
                />
            </svg>
        );
    }
}
